import { Component, HostListener } from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';

@Component({
  selector: 'app-portfolio-detail',
  templateUrl: './portfolio-detail.component.html',
  styleUrl: './portfolio-detail.component.css'
})
export class PortfolioDetailComponent {
  isTransparent = true;
  isMenuOpen = false;
  activeDropdown: number | null = null;

  toggleMenu(): void {
    this.isMenuOpen = !this.isMenuOpen;
  }

  toggleDropdown(index: number): void {
    this.activeDropdown = this.activeDropdown === index ? null : index;
  }

  closeMenu(): void {
    this.isMenuOpen = false;
    this.activeDropdown = null;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    const target = event.target as HTMLElement;
    if (!target.closest('.nav-item') && !target.closest('.header-toggle')) {
      this.activeDropdown = null;
    }
  }

  @HostListener('window:scroll', [])
  onWindowScroll(): void {
    const offset = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    this.isTransparent = offset < 100;
  }

  //Header End

  //Brand Logos
  brands = [
    { image: 'assets/images/brands/brand-1.png', alt: 'brand-1' },
    { image: 'assets/images/brands/brand-2.png', alt: 'brand-2' },
    { image: 'assets/images/brands/brand-3.png', alt: 'brand-3' },
    { image: 'assets/images/brands/brand-4.png', alt: 'brand-4' },
    { image: 'assets/images/brands/brand-5.png', alt: 'brand-5' },
    { image: 'assets/images/brands/brand-6.png', alt: 'brand-6' }
  ];

  brandCarouselOptions = {
    loop: true,
    margin: 50,
    autoplay: true,
    nav: false,
    dots: false,
    responsive: {
      0: { items: 1 },
      576: { items: 2 },
      768: { items: 3 },
      992: { items: 5 },
      1200: { items: 5 }
    }
  };
}
